import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/New-York.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Shaping the Digital Transformation Wave in New York</h2>
            <p>
              Embark on a journey of unparalleled expertise with TekRevol's
              mobile app development services in New York City. We combine
              exceptional expertise, innovative breakthroughs, and top-notch
              coding standards to set new standards for digital excellence.
            </p>
            <p>
              With a stellar repute, we launch businesses towards their
              objectives using ground-breaking solutions and revolutionary
              technology. Our pledge grows beyond development, providing
              dedicated aftersales customer support and secure cloud-based
              hosting for an effortless digital journey.
            </p>
            <p>
              Empowering enterprises with in-built mobile app solutions, we
              clear the way for considerable revenue growth. Start your digital
              transformation journey today with TekRevol and reform your
              business in the digital landscape for the future.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="mobile app development company in new york"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
